import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import { getActionsListApi } from "../../../api/api";
import { useVisionContext } from "../../ContextAPI/VisionContext";

const actionOptions = [
  "Email",
  "Automated Call (IVR)",
  "Push Notification",
  "Alarm Sound",
  "Alert on Screen",
  "Slack/Teams Notification",
];

const ActionModal = ({ onClose, onSubmit }) => {
  const [selectedActions, setSelectedActions] = useState([]);
  const [actions, setActions] = useState([]);

  const { visionData, updateState } = useVisionContext();

  const fetchAction = async () => {
    try {
      const data = await getActionsListApi();
      if (data?.data?.status === true) {
        setActions(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchAction();
  }, []);

  const dispatch = useDispatch();
  const handleCheckboxChange = (label) => {
    setSelectedActions((prev) =>
      prev.includes(label)
        ? prev.filter((item) => item !== label)
        : [...prev, label]
    );
  };

  const handleSubmit = () => {
    updateState("actionTypeIds", selectedActions);

    if (onSubmit) onSubmit(selectedActions);
    handleClose();
  };
  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };
  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">Action</h4>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <p className="form-label mb-3">Select Action</p>
        <div className="action-grid">
          {actions &&
            actions?.map((label, index) => (
              <label className="checkbox-label" key={index}>
                <input
                  type="checkbox"
                  checked={selectedActions.includes(label?._id)}
                  onChange={() => handleCheckboxChange(label?._id)}
                />
                <span>{label?.action_name}</span>
              </label>
            ))}
        </div>

        <div className="bottomBtn d-flex justify-content-between mt-4">
          <button className="cancel-btn" onClick={handleClose}>
            Cancel
          </button>
          <button className="submit-btn" onClick={handleSubmit}>
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActionModal;
